import { IApplicationState } from '../../types/redux';

export const selectMeta = (state: IApplicationState) => state.filters.meta;
